const internationalEventDetails = [
  {
    path: "",
    name: "international-event",
    meta: {
      breadcrumb: "International-Event",
      title: "",
    },
    component: () => import("@/components/InternationalEvent/Index"),
  },
  {
    path: "tickets",
    name: "international-ticket-listing",
    props: true,
    component: () =>
      import("@/components/InternationalEvent/InternationalTicketLisitings"),
  },
  {
    path: "booking",
    name: "InternatioanlEventBooking",
    component: () =>
      import("@/components/InternationalEvent/TicketBooking/TicketBooking"),
    props: true,
    children: [
      {
        path: "",
        redirect: { name: "InternationalEventPayment" },
      },
      {
        path: "payment",
        name: "InternationalEventPayment",
        component: () =>
          import(
            "@/components/InternationalEvent/TicketBooking/InternationalEventPayment"
          ),
        props: true,
      },
    ],
  },
   
];
export default internationalEventDetails;
